import UiFab, { type FabProps } from '@mui/material/Fab';
import { forwardRef } from 'react';

type Props = Omit<FabProps, 'sx'> & {
  offset?: boolean;
};

export const BottomFab = forwardRef<HTMLButtonElement, Props>(function BottomFab({ children, offset, ...rest }, ref) {
  return (
    <UiFab
      color="primary"
      size="medium"
      sx={{
        bottom: offset ? 80 : 16,
        position: 'fixed',
        right: 16,
        textTransform: 'none',
      }}
      ref={ref}
      {...rest}
    >
      {children}
    </UiFab>
  );
});
